<template>
  <div class="guide">
	    <button>
		  <a :href="pdf" :download="pdf" target="_blank"><i class="el-icon-tickets"></i> 操作指南</a> 
	    </button>
  </div>
</template>
<script>
	export default {
		name:"Guide",
		data() {
			return{
				pdf:'https://sdb-oss.ktnw.cn/file/三秦好少年操作指南.pdf'
			}
		}
	}
</script>
<style lang="scss" scoped>
	.guide {
		button{
			font-size: 15px;
			color: #bc463b;
			width: 120px;
			height: 40px;
			background: #FFFFFF;
			border-radius: 20px;
			border: 1px solid #bc463b;
			cursor: pointer;
			padding: 0;
			&:hover{
				background: #ffe8e5;
			}
			a{
				display: block;
				color: inherit;
				height: 100%;
				line-height: 38px;
				text-decoration: none;
				text-align: center;
			}
			.el-icon-tickets{
				font-size: 22px;
				vertical-align: middle;
			}
		}
	}
</style>